import React from 'react';

import { ILink } from 'utils/types';
import { Catalog } from 'components/catalog/Catalog';
import { Product } from 'components/catalog/Product';
import { Variant } from 'components/catalog/Variant';

export const Component = () => {
  const [openProducts, setOpenProducts] = React.useState(null);
  const image = { url: 'https://picsum.photos/id/1081/90/60', width: 90, height: 60 };

  return (
    <Catalog title="Product Catalog" tagline="Products" isSlice>
      <Product
        title="Acarbose Tablets"
        onClick={() => setOpenProducts(openProducts === 0 ? null : 0)}
        active={openProducts === 0}
      >
        <Variant
          image={image}
          ndc="47781-340-01"
          strength="25 mg"
          size="100"
          cgn="08070"
          seq="36767"
        />
        <Variant
          image={image}
          ndc="47781-341-01"
          strength="50 mg"
          size="100"
          cgn="02319"
          seq="20242"
        />
        <Variant
          image={image}
          ndc="47781-340-01"
          strength="25 mg"
          size="100"
          cgn="02318"
          seq="20241"
        />
      </Product>
      <Product
        title="Buprenorphine and Naloxone Sublingual Film C-III"
        onClick={() => setOpenProducts(openProducts === 1 ? null : 1)}
        active={openProducts === 1}
      >
        <Variant
          image={image}
          ndc="47781-340-01"
          strength="2 mg/0.5 mg"
          size="30"
          cgn="08070"
          seq="36767"
        />
        <Variant
          image={image}
          ndc="47781-341-01"
          strength="50 mg"
          size="100"
          cgn="02319"
          seq="20242"
        />
        <Variant
          image={image}
          ndc="47781-340-01"
          strength="25 mg"
          size="100"
          cgn="02318"
          seq="20241"
        />
      </Product>
      <Product
        title="Bupropion Hydrochloride Extended-Release Tablets"
        warning
        infoLink={
          {
            href: 'http://mbl.is',
          } as ILink
        }
        hasRems
        remsLink={
          {
            href: 'https://kodo.is',
          } as ILink
        }
        onClick={() => setOpenProducts(openProducts === 2 ? null : 2)}
        active={openProducts === 2}
      >
        <Variant
          image={image}
          ndc="47781-340-01"
          strength="2 mg/0.5 mg"
          size="30"
          cgn="08070"
          seq="36767"
        />
        <Variant
          image={image}
          ndc="47781-341-01"
          strength="50 mg"
          size="100"
          cgn="02319"
          seq="20242"
        />
        <Variant
          image={image}
          ndc="47781-340-01"
          strength="25 mg"
          size="100"
          cgn="02318"
          seq="20241"
        />
      </Product>
    </Catalog>
  );
};
